module.exports = __webpack_public_path__ + "static/media/checkbox-checked.336023cc.svg";